import React, { useRef } from "react";
import AccordionPanels from "../AccordionPanels.js";
import TimelinePanels from "../TimelinePanels.js";

const timelinePanels = [
    "1788 - 1792",
    "1793 - 1796",
    "1797 - 1800",
    "1801 - 1804",
    "1805 - 1809",
];
const timelinePanels2 = [
    "1786 - 1788",
    "1789 - 1798",
    "1799 - 1806",
];
const timelinePanels3 = [
    "1783 - 1796",
    "1798 - 1801",
];
const ManuscriptsData = () => {
    const panels = [
        {
            title: "A. Harry Ransom Humanities Research Center, University of Texas (40 letters)",
            content: `

          <p>
          1.
           #5 To Wilkins, No Date, 870 words<br /> 2.
           #6 To Wilkins, No Date, 1318 words<br /> 3.
           #38 To Wilkins, 22 January 1793, 748 words<br /> 4.
           #116 To Unknown, 15 December 1800, 1005 words<br /> 5.
           #117 To Eliza Linn, 17 February 1801, 277 words<br /> 6.
           #118 To Eliza Linn, 20 February 1801, 923 words<br /> 7.
           #119 To Eliza Linn, 28 February 1801, 317 words<br /> 8.
           #120 To Eliza Linn, 2 March 1801, 573 words<br /> 9.
           #121 To Eliza Linn, Undated, 857 words<br /> 10.
           #122 To Eliza Linn, 6 March 1801, 630 words<br /> 11.
           #123 To Eliza Linn, 10 March 1801, 828 words<br /> 12.
           #124 To Eliza Linn, Undated, 239 words<br /> 13.
           #125 To Eliza Linn, 17-18 March 1801, 1067 words<br /> 14.
           #126 To Eliza Linn, Undated, 557 words<br /> 15.
           #127 To Eliza Linn, 23 March 1801, 1152 words<br /> 16.
           #128 To Eliza Linn, 27 March 1801, 686 words<br /> 17.
           #129 To Eliza Linn, 30 March 1801, 657 words<br /> 18.
           #130 To Eliza Linn, 31 March 1801, 913 words<br /> 19.
           #131 To Eliza Linn, 1 April 1801, 619 words<br /> 20.
           #132 To Eliza Linn, 2 April 1801, 552 words<br /> 21.
           #133 To Eliza Linn, 3-4 April 1801, 1138 words<br /> 22.
           #134 To Eliza Linn, 6 April 1801, 695 words<br /> 23.
           #135 To Eliza Linn, 9 April 1801, 1049 words<br /> 24.
           #136 To Eliza Linn, 10 April 1801, 961 words<br /> 
           #135 To Eliza Linn, 11 April 1801, 954 words<br /> 
           #137 To Eliza Linn, 13 April 1801, 609 words<br /> 26.
           #138 To Eliza Linn, 14 April 1801, 558 words<br /> 27.
           #139 To Eliza Linn, 16 April 1801, 701 words<br /> 28.
           #140 To Eliza Linn, Undated, 327 words<br /> 29.
           #141 To Eliza Linn, 19 April 1801, 463 words<br /> 30.
           #142 To Eliza Linn, Undated, 761 words<br /> 31.
           #143 To Eliza Linn, 27 April 1801, 572 words<br /> 32.
           #144 To Eliza Linn, 29 April 1801, 905 words<br /> 
           #145 To Eliza Linn, Undated, 114 words<br />
           #145 To Eliza Linn, Undated, 340 words<br /> 34.
           #154 To Eliza Linn, Undated, 184 words<br /> 35.
           #156 To Eliza Linn, 15 November [1802], 263 words<br /> 36.
           #157 To Eliza Linn, 7 December [1802], 698 words <br /> 37.
           #158 To Eliza Linn, 21 December [1802], 197 words<br /> 38.
           #159 To Eliza Linn, 15 January [1803], 199 words<br /> 39.
           #162 To Eliza Linn, 18 March 1803, 155 words<br /> 40.
           #164 To Eliza Linn, 25 March 1804, 277 words</p>
          `,
        },
        {
            title: "B. Hawthorne-Longfellow Library, Bowdoin College (44 letters)",
            content: `
  <p>1. #4 To Bringhurst, 20 March 1792, 1263 words<br /> 2.
  #7 To Bringhurst, 5 May 1792, 1988 words<br /> 3.
  #8 To Bringhurst, [6] May 1792, 1678 words<br /> 4.
  #9 To Bringhurst, 7 May 1792, 630 words<br /> 5.
  #10 To Bringhurst Undated, 987 words<br /> 6.
  #11 To Bringhurst 9 May 1792, 202 words<br /> 7.
  #13 To Bringhurst, 15 May 1792, 2011 words<br /> 8.
  #15 To Bringhurst, [1792], 2572 words<br /> 9.
  #16 To Bringhurst 19 May 1792<br /> 10.
  #17 To Bringhurst, 20 May 1792, 5061 words<br /> 11.
  #18 To Bringhurst, 30 May 1792, 1539 words<br /> 12.
  #19 To Bringhurst, 1 June 1792, 846 words<br /> 13.
  #20 To Bringhurst, [June 1792], 248 words<br /> 14.
  #21 To Bringhurst, 9 June 1792, 800 words<br /> 15.
  #22 To Bringhurst, 10 June 1792, 1074 words<br /> 16.
  #24 To Bringhurst, 9 August 1792, 956 words<br /> 17.
  #25 To Bringhurst, October-November 1792, 834 words<br /> 18.
  #26 To Bringhurst, October-November 1792, 2120 words<br /> 19.
  #27 To Bringhurst, October-November 1792, 2382 words<br /> 20.
  #32 To Bringhurst, December 1792, 1549 words<br /> 21.
  #33 To Bringhurst, 9 December 1792, 2957 words<br /> 22.
  #34 To Bringhurst, 11 December 1792, 834 words<br /> 23.
  #35 To Bringhurst, undated, 1309 words <br /> 24.
  #36 To Bringhurst, 21 December 1792, 2832 words<br /> 25.
  #39 To Bringhurst, 21 April 1793, 154 words<br /> 26.
  #40 To Bringhurst, 22 April 1793, 440 words<br /> 27.
  #41 To Bringhurst, [April-May 1793], 965 words<br /> 28.
  #42 To Bringhurst, 22 May 1793, 567 words<br /> 29.
  #43 To Bringhurst, 11 June 1793, 1164 words<br /> 30.
  #44 To Bringhurst, [July] 1793, 986 words<br /> 31.
  #45 To Bringhurst, 25 July 1793, 985 words<br /> 32.
  #46 To Bringhurst, 29 July 1793, 2997 words<br /> 33.
  #47 To Bringhurst, 16 August 1793, 465 words<br /> 34.
  #48 To Bringhurst, 20 December 1793-8 January 1794, 715 words<br /> 35.
  #51 To Deborah Ferris, 4 October 1794, 125 words<br /> 36.
  #57 To Bringhurst, 24 October 1795, 2984 words<br /> 37.
  #58 To Bringhurst, 30 October 1795, 441 words<br /> 38.
  #61 To Bringhurst, 29 December 1795, 796 words<br /> 39.
  #62 To Bringhurst, 1 January 1796, 212 words<br /> 40.
  #66 To Bringhurst, 11 May 1796, 675 words<br /> 41.
  #69 To Bringhurst, 11 July 1796, 414 words<br /> 42.
  #70 To Bringhurst, 20 July 1796, 1946 words<br /> 43.
  #74 To Bringhurst, 19 September 1796, 292 words<br /> 44.
  #82 To Bringhurst, 18 August 1797, 582 words</p>

          `,
        },
        {
            title: "C. Special Collections, University of Delaware (11 letters)",
            content: `
  <p>
1. 1792-L-023A, To William Wood Wilkins,[Summer 1792], 174 words<br />
2. 1792-L-047A, To Joseph Bringhurst, Jr., 29 August 1793, 444 words<br />
3. 1794-L-049A, To Joseph Bringhurst, Jr., 24 February 1794, 2293 words<br />
4. 1796-L-066A, To Joseph Bringhurst, Jr., 13 May 1796, 1235 words<br />
5. 1796-L-075A, To Joseph Bringhurst, Jr., 10 January 1797, 1607 words<br />
6. 1797-L-076A, To Joseph Bringhurst, Jr., 14 March 1797, 804 words<br />
7. 1797-L-077A, To Joseph Bringhurst, Jr., 24 March 1797, 846 words<br />
8. 1797-L-083A, To Joseph Bringhurst, Jr., 21 September 1797, 569 words<br />
9. 1798-L-0103A, To Joseph Bringhurst, Jr., [Between 19 and 24 September 1798], 68 words<br />
10. 1798-L-106A, To Joseph Bringhurst, Jr., 20 October 1798, 753 words<br />
11. 1799-L-111A, To Joseph Bringhurst, Jr., 19 March 1799, 1431 words<br />

            `,
        },
        {
            title: "D. Clifton Waller Barrett Collection, University of Virginia (9 letters)",
            content: `
<p>1.
  #3 To Wilkins, [1791], 1263 words<br /> 2.
  #28 To Wilkins, [1792], 2215 words<br /> 3.
  #30 To Wilkins, [November 1792], 1123 words<br /> 4.
  #53 To James Brown, 19 April 1795, 389 words<br /> 5.
  #100 To Maria Nicholson, [September?] 1798, 314 words<br /> 6.
  #113 To William Pitt Beers, 12 February 1800, 143 words<br /> 7.
  #148 To Mary Linn, 9 January 1802, 239 words<br /> 8.
  #174 To John Elihu Hall, 21 November 1806, 566 words<br /> 9.
  #176 To John B. Romeyn, 18 January 1808, 516 words</p>
          `,
        },
        {
            title: "E. Historical Society of Pennsylvania (6 letters)",
            content: `
  #1 To [?], 13 June 1788, 479 words<br /> 2.
  #49 To William Johnson, 13 February 1794, 258 words<br /> 3.
  #84 To William Dunlap, 1 January 1798, 288 words<br /> 4.
  #166 To William Linn, 8 December 1804, 318 words<br /> 5.
  #167 To William Dunlap, 25 February 1805, 565 words<br /> 6.
  #170 To Elizabeth Linn Brown, 17 June 1806, 567 words</p>

            `,
        },
        {
            title: "F. Firestone Library, Princeton University (3 letters)",
            content: `
<p>1.
  #14 To Wilkins, No Date [1792] 1453 words <br />
2.  
  #161 To Samuel Miller, 16 March 1803, 621 words <br />
3.
  #163 To Samuel Miller, 20 June 1803, 140 words <br />
</p>
            `,
        },
        {
            title: "G. Quaker Collection, Haverford College (2 letters)",
            content: `
<p> 1.
  #146 To John Elihu Hall, 8 May 1801, 35 words </br />
   2.
  #171 To John Elihu Hall, 26 July 1806, 872 words</p>

            `,
        },
        {
            title: "H. Private Collection(s), sold by The Rendells, Inc., 1990 (1 letter)",
            content: `
<p>1.#12 To Wilkins, No Date, 1336 words</p>

            `,
        },
        {
            title: "I. Butler Library, Columbia University (1 letter)",
            content: `
<p>1.#73 To James Brown, 1 September 1796, 247 words</p>

            `,
        },
        {
            title: "J. Houghton Library, Harvard University (1 letter)",
            content: `
<p>1. #149 To [William Johnson], 4 May 1802</p>

            `,
        },
        {
            title: "K. Library Company of Philadelphia (1 letter)",
            content: `
<p>1.#75 To James Brown, 25 October 1796, 981 words</p>

            `,
        },
        {
            title: "L. Library of Congress (1 letter)",
            content: `
<p> 1. #108 To Thomas Jefferson, 15 December 1798, 500 words</p>

            `,
        },
        {
            title: "M. New York Historical Society (1 letter)",
            content: `
<p>1. #177 To Albert Gallatin, 12 January 1809, 161 words</p>

            `,
        },
        {
            title: "N. New York Public Library (1 letter)",
            content: `
<p>1. #150 To John Blair Linn, 8 July 1802, 569 words</p>

            `,
        },
    ];
    const timelineContentRef = useRef(null);
    const timelineContentRef2 = useRef(null);
    const timelineContentRef3 = useRef(null);

    const getContent = (panel, contentRef) => {
        if (!contentRef.current) return "";

        const [startYear, endYear] = panel.split(" - ").map(Number);
        const headings = Array.from(contentRef.current.querySelectorAll(".cbb_bold"));

        let matchedHTML = [];

        headings.forEach((heading) => {
            const year = parseInt(heading.textContent.trim(), 10);

            if (year >= startYear && year <= endYear) {
                const wrapper = document.createElement("div");
                wrapper.className = "timeline-year";

                // Create <h4> for each matched year
                const yearHeading = document.createElement("h4");
                yearHeading.className = "timeline-year-heading";
                yearHeading.textContent = `${year}`;
                wrapper.appendChild(yearHeading);

                let next = heading.nextElementSibling;
                while (next && next.tagName === "P" && next.classList.contains("hindent")) {
                    wrapper.appendChild(next.cloneNode(true));
                    next = next.nextElementSibling;
                }

                matchedHTML.push(wrapper.outerHTML);
            }
        });

        if (matchedHTML.length) {
            return `<div class="timeline">${matchedHTML.join("")}</div>`;
        }

        return "";
    };

    return (
        <>
            <TimelinePanels
                panels={timelinePanels}
                getContent={(panel) => getContent(panel, timelineContentRef)}
            />
            <div ref={timelineContentRef} style={{ display: "none" }}>
                <p class="cbb_bold">1788</p>
                <p class="hindent">1788-L-001&nbsp;To Unknown, 13 June 1788. (B1, HC2) "A Wilcocks went out of town" MS HSP</p>
                <p class="cbb_bold">1790</p>
                <p class="hindent">1790-L-002&nbsp;To [John Davidson], [Before December 1790] (B3, HC4) "Emilius, the friend of Charles" No MS: Paraphrase Allen, 44-46</p>
                <p class="cbb_bold">1791</p>
                <p class="hindent">1791-L-003&nbsp;To William Wood Wilkins, [Late 1791] (B4, HC5) "Listen my friend, the diallogue is short" MS Virginia</p>
                <p class="cbb_bold">1792</p>
                <p class="hindent">1792-L-004&nbsp;To Joseph Bringhurst, Jr., [20 March 1792] (B5, HC6) "It is certain that in general the excellence" MS Bowdoin
                </p>
                <p class="hindent">1792-L-005&nbsp;To William Wood Wilkins, [Early or mid 1792] (B6, HC7) "Here I am seated at my desk" MS Texas
                </p>
                <p class="hindent">1792-L-006&nbsp;To William Wood Wilkins, [Summer 1792] (B7, HC8) "What, my friend, art thou certainly awake?" No MS: Transcript Allen, 57-60</p>
                <p class="hindent">1792-L-007&nbsp;To Joseph Bringhurst, Jr., Received 5 May 1792 (B12, HC13) "I have been conversing with Rousseau" MS Bowdoin
                </p>
                <p class="hindent">1792-L-008&nbsp;To Joseph Bringhurst, Jr., 6 May 1792 (B13, HC14) "Oh, my friend!" MS Bowdoin
                </p>
                <p class="hindent">1792-L-009&nbsp;To [Joseph Bringhurst, Jr.], [7 May 1792] (B14, HC15) "Consolation didst thou say?" MS Bowdoin
                </p>
                <p class="hindent">1792-L-010&nbsp;To [Joseph Bringhurst, Jr.], [May 1792] (B15, HC16) "Tarry a little, my good friend" MS Bowdoin
                </p>
                <p class="hindent">1792-L-011&nbsp;To [Joseph Bringhurst, Jr.], Received 9 May 1792 (B16, HC17) "I devote almost all my leisure" MS Bowdoin
                </p>
                <p class="hindent">1792-L-012&nbsp;To William Wood Wilkins, [May 1792] (B17, HC18) "Why is my inclination" No MS: Transcript Clark 1948, 79-82</p>
                <p class="hindent">1792-L-013&nbsp;To Joseph Bringhurst, Jr., 13 May 1792 (B18, HC19) "I very much regret" MS Bowdoin
                </p>
                <p class="hindent">1792-L-014&nbsp;To William Wood Wilkins, [May 1792] (B19, HC20) "Write to me my friend, I beseach you" MS Princeton
                </p>
                <p class="hindent">1792-L-015&nbsp;To Joseph Bringhurst, Jr., Received 16 May 1792 (B20, HC21) "I have, my dearest friend, pretty copiously" MS Bowdoin
                </p>
                <p class="hindent">1792-L-016&nbsp;To Joseph Bringhurst, Jr., [19] May 1792 (B21, HC22) "My friend, I cannot express the pleasure" MS Bowdoin
                </p>
                <p class="hindent">1792-L-017&nbsp;To Joseph Bringhurst, Jr., Received 20 May 1792 (B22, HC23) "Proceed my friend in your career" MS Bowdoin
                </p>
                <p class="hindent">1792-L-018&nbsp;To Joseph Bringhurst, Jr., 30 May 1792 (B23, HC24) "I am extreemly pleased with your vision" MS Bowdoin
                </p>
                <p class="hindent">1792-L-019&nbsp;To Joseph Bringhurst, Jr., 1 June 1792 (B24, HC25) "There are certain persons who" MS Bowdoin
                </p>
                <p class="hindent">1792-L-020&nbsp;To Joseph Bringhurst, Jr., [Between 1 and 9 June 1792] (B25, HC26) "Thou receivest this because it is intended" MS Bowdoin
                </p>
                <p class="hindent">1792-L-021&nbsp;To Joseph Bringhurst, Jr., 9 June 1792 (B26, HC27) "I am extremely sorry to hear" MS Bowdoin
                </p>
                <p class="hindent">1792-L-022&nbsp;To Joseph Bringhurst, Jr., 10 June 1792 (B27, HC28) "As I have already observed" MS Bowdoin
                </p>
                <p class="hindent">1792-L-023&nbsp;To [William Wood Wilkins], [Summer 1792] (B28, HC29) "I have read your letter. It is short." No MS: Transcript Allen, 50-55</p>
                <p class="hindent">1792-L-024&nbsp;To Joseph Bringhurst, Jr., 9 August 1792 (B30, HC31) "How pleasing is the converse" MS Bowdoin
                </p>
                <p class="hindent">1792-L-025&nbsp;To Joseph Bringhurst, Jr., [Oct.-Nov. 1792] (B8, HC9) "I have read your letter by favour of my friend" MS Bowdoin
                </p>
                <p class="hindent">1792-L-026&nbsp;To Joseph Bringhurst, Jr., [Oct.-Nov. 1792] (B9, HC10) "No sooner have I read your letter" MS Bowdoin
                </p>
                <p class="hindent">1792-L-027&nbsp;To Joseph Bringhurst, Jr., [Oct.-Nov. 1792] (B10, HC11) "I have read your letter with the utmost satisfaction" MS Bowdoin
                </p>
                <p class="hindent">1792-L-028&nbsp;To William Wood Wilkins, [After October 1792] (B11, HC12) "The more I reflect the more clearly do I perceive" MS Virginia
                </p>
                <p class="hindent">1792-L-029&nbsp;To William Wood Wilkins, 3 November 1792 (B31, HC32) "I have, at this moment" No MS: Transcript Clark 1948, 93-95</p>
                <p class="hindent">1792-L-030&nbsp;To William Wood Wilkins, November 1792 (B33, HC33) "I am glad to see you" MS Virginia
                </p>
                <p class="hindent">1792-L-031&nbsp;To William Wood Wilkins, [Between 5 and 27 November 1792] (B32, H34) "Why, my friend, is there so" No MS: Transcript Allen, 61-67</p>
                <p class="hindent">1792-L-032&nbsp;To Joseph Bringhurst, Jr., 1 December 1792 (B34, HC35) "There is a kind of intercourse which" MS Bowdoin
                </p>
                <p class="hindent">1792-L-033&nbsp;To Joseph Bringhurst, Jr., 9 December 1792 (B35, HC36) "You seem, my friend, to think" MS Bowdoin
                </p>
                <p class="hindent">1792-L-034&nbsp;To Joseph Bringhurst, Jr., 11 December 1792 (B36, HC37) "You impose the task of writing on me" MS Bowdoin
                </p>
                <p class="hindent">1792-L-035&nbsp;To Joseph Bringhurst, Jr., [13 December 1792] (B29, HC30) "I must solicit your forgiveness" MS Bowdoin
                </p>
                <p class="hindent">1792-L-036&nbsp;To Joseph Bringhurst, Jr., 21 December 1792 (B38, HC38) "What an abundance of absurdity" MS Bowdoin
                </p>
                <p class="hindent">1792-L-037&nbsp;To William Wood Wilkins, 31 December 1792 (B37, HC39) "I received a letter from you" No MS: Transcript Clark 1948, 101-103</p>
                <p class="cbb_bold">1793</p>
                <p class="hindent">1793-L-038&nbsp;To William Wood Wilkins, 22 January 1793 (B39, HC40) MS Texas
                </p>
                <p class="hindent">1793-L-039&nbsp;To Joseph Bringhurst, Jr., [Before 21 April 1793] (B41, HC41) "I said truth when I said" MS Bowdoin
                </p>
                <p class="hindent">1793-L-040&nbsp;To Joseph Bringhurst, Jr., 21 April 1793 (B40, HC42) "I have so long been" MS Bowdoin
                </p>
                <p class="hindent">1793-L-041&nbsp;To Joseph Bringhurst, Jr., [April-May 1793] (B42, HC43) "The anxiety which you express" MS Bowdoin
                </p>
                <p class="hindent">1793-L-042&nbsp;To Joseph Bringhurst, Jr., 22 May 1793 (B43, HC44) "You have doubtless been concerned" MS Bowdoin
                </p>
                <p class="hindent">1793-L-043&nbsp;To Joseph Bringhurst, Jr., 11 June 1793 (B44 & B46, HC45) "I have just received your most" MS Bowdoin
                </p>
                <p class="hindent">1793-L-044&nbsp;To Joseph Bringhurst, Jr., [Before 22 July 1793 (B45, HC46) "I reflect upon my present situation" MS Bowdoin
                </p>
                <p class="hindent">1793-L-045&nbsp;To Joseph Bringhurst, Jr., 25 July 1793 (B47, HC47) "It is with relectance that I" MS Bowdoin
                </p>
                <p class="hindent">1793-L-046&nbsp;To Joseph Bringhurst, Jr., 29 July and 1 August 1793 (B48, HC48) "I cannot help regretting that" MS Bowdoin
                </p>
                <p class="hindent">1793-L-047&nbsp;To Joseph Bringhurst, Jr., 16 August 1793 (B49, HC49) "Your last very curious" MS Bowdoin
                </p>
                <p class="hindent">1793-L-048&nbsp;To Joseph Bringhurst, Jr., [After 20 December 1793 and 8 January 1794] (B50 & B66, HC50) "I was sitting in the humble" MS Bowdoin
                </p>
                <p class="cbb_bold">1794</p>
                <p class="hindent">1794-L-049&nbsp;To William Johnson, 13 February 1794 (B51, HC51) "Mr. Smith, the pleasure" MS HSP
                </p>
                <p class="hindent">1794-L-050&nbsp;To William Dunlap, 13 August 1794 (B52, HC52) "It will doubtless be pleasing" No MS: Transcript Dunlap 1834, III.33</p>
                <p class="hindent">1794-L-051&nbsp;To Deborah Ferris, 4 October 1794. (Not in B, HC53) "Most respected friend" MS Bowdoin
                </p>
                <p class="hindent">1794-L-052&nbsp;To William Dunlap, 28 November 1794 (B53, HC54) "How many weeks have" No MS: Transcript Dunlap 1815, II.91-93</p>
                <p class="cbb_bold">1795</p>
                <p class="hindent">1795-L-053&nbsp;To James Brown, 19 April 1795 (B56, HC55) "Our brother Joseph is just leaving" MS Virginia
                </p>
                <p class="hindent">1795-L-054&nbsp;To William Dunlap, September 1795 (B59, HC56) "Soon after my return" No MS: Transcript Dunlap 1834, III.3</p>
                <p class="hindent">1795-L-055&nbsp;To Elihu Hubbard Smith, Received 22 September 1795 (B60, HC57) No MS: Paraphrase and receipt noted Smith, 60 and 74</p>
                <p class="hindent">1795-L-056&nbsp;To Elihu Hubbard Smith, Received 23 October 1795 (B61, HC58) No MS: Receipt noted Smith, 80</p>
                <p class="hindent">1795-L-057&nbsp;To Joseph Bringhurst, Jr., 24 October 1795 (B62B63, HC59) "I have just received your letter" MS Bowdoin
                </p>
                <p class="hindent">1795-L-058&nbsp;To Joseph Bringhurst, Jr., 30 October 1795 (B64, HC60) "I shall not I fear be able" MS Bowdoin
                </p>
                <p class="hindent">1795-L-059&nbsp;To Elihu Hubbard Smith, 10 December 1795 (B65, HC61) No MS: Paraphrase Smith, 100-101, 102, 114</p>
                <p class="hindent">1795-L-060&nbsp;To Elihu Hubbard Smith, Received 30 December 1795 (B68, HC63) No MS: Paraphrase Smith, 117</p>
                <p class="hindent">1795-L-061&nbsp;To Joseph Bringhurst, Jr., 29 and 30 December 1795 (B67, HC62) "I was going to apologize" MS Bowdoin
                </p>
                <p class="cbb_bold">1796</p>
                <p class="hindent">1796-L-062&nbsp;To Joseph Bringhurst, Jr., 1 January 1796 (B69, HC64) "I have just received yours" MS Bowdoin
                </p>
                <p class="hindent">1796-L-063&nbsp;To William Dunlap, February 1796 (B70, HC65) "After wandering through fifty" No MS: Transcript and paraphrase Dunlap 1834, III.3-4</p>
                <p class="hindent">1796-L-064&nbsp;To Elihu Hubbard Smith, Received 23 April 1796 (B71, HC66) No MS: Paraphrase and transcript Smith, 158, 163-164</p>
                <p class="hindent">1796-L-065&nbsp;To Elihu Hubbard Smith, 10 May 1796 (B72, HC67) No MS: Transcript and paraphrase: Smith, 167 and 170-171</p>
                <p class="hindent">1796-L-066&nbsp;To Joseph Bringhurst, Jr., 11 May 1796 (B73, HC68) "Thou escaped'st, my good friend" MS Bowdoin
                </p>
                <p class="hindent">1796-L-067&nbsp;To William Dunlap and Elihu Hubbard Smith, Received 17 May 1796 (B74, HC69) No MS: Receipt noted Smith, 168</p>
                <p class="hindent">1796-L-068&nbsp;To Elihu Hubbard Smith, Received 7 July 1796 (B75, HC70) No MS: Transcript and paraphrase Smith, 184</p>
                <p class="hindent">1796-L-069&nbsp;To Joseph Bringhurst, Jr., 11 July 1796 (B76, HC71) "Why have I not lately heard from thee, Josepho?" MS Bowdoin
                </p>
                <p class="hindent">1796-L-070&nbsp;To Joseph Bringhurst, Jr., 20 July 1796 (B77, HC72) "How shall I account" MS Bowdoin
                </p>
                <p class="hindent">1796-L-071&nbsp;To Elihu Hubbard Smith, Received 21 July 1796 (B78, HC73) No MS: Receipt noted Smith, 188</p>
                <p class="hindent">1796-L-072&nbsp;To Elihu Hubbard Smith, Received 1 August 1796 (B79, HC74) No MS: Paraphrase Smith, 197</p>
                <p class="hindent">1796-L-073&nbsp;To James Brown, 1 September 1796 (B80, HC75) "[...]pectations of the beginning of last week" MS Columbia
                </p>
                <p class="hindent">1796-L-074&nbsp;To Joseph Bringhurst, Jr., 14 September 1796 (Not in B, HC76) "I came hither yesterday." MS Bowdoin
                </p>
                <p class="hindent">1796-L-075&nbsp;To James Brown, 25 October 1796 (B81, HC77) "I have been busy" MS LCP
                </p>
                <p class="cbb_bold">1797</p>
                <p class="hindent">1797-L-076&nbsp;To Elihu Hubbard Smith, Received 21 January 1797 (B82, HC78) No MS: Receipt noted Smith, 282</p>
                <p class="hindent">1797-L-077&nbsp;To [William] Johnson, Received 23 March 1797 (B83, HC79) No MS: Receipt noted Smith, 302</p>
                <p class="hindent">1797-L-078&nbsp;To Elihu Hubbard Smith, Received 27 April 1797 (B84, HC80) No MS: Receipt noted Smith, 314</p>
                <p class="hindent">1797-L-079&nbsp;To Elihu Hubbard Smith, Received 7 June 1797 (B85, HC81) </p>
                <p class="hindent">1797-L-080&nbsp;To Elihu Hubbard Smith, Received 18 July 1797 (B86, HC82) No MS: Receipt noted Smith, 323; Paraphrase and transcript Smith, 336-337, 338</p>
                <p class="hindent">1797-L-081&nbsp;To Elihu Hubbard Smith, Received 7 August 1797 (B87, HC83) </p>
                <p class="hindent">1797-L-082&nbsp;To Joseph Bringhurst, Jr., 19 August 1797 (B88, HC84) "I arrived safely in town at 2 OClock" MS Bowdoin
                </p>
                <p class="hindent">1797-L-083&nbsp;To Elihu Hubbard Smith, Received 29 August 1797 (B89, HC85) No MS: Paraphrase and receipt noted Smith, 352 and 364</p>
                <p class="cbb_bold">1798</p>
                <p class="hindent">1798-L-084&nbsp;To William Dunlap, Received 1 January 1798 (B90, HC86) "It is nearly twelve months since I parted from you" MS HSP
                </p>
                <p class="hindent">1798-L-085&nbsp;To Elihu Hubbard Smith, Received 2 January 1798 (B91, HC87) No MS: Paraphrase and receipt noted Smith, 413, 417-18</p>
                <p class="hindent">1798-L-086&nbsp;To Elihu Hubbard Smith, Received 27 March 1798 (B92, HC88) No MS: Paraphrase Smith, 433-434</p>
                <p class="hindent">1798-L-087&nbsp;To Elihu Hubbard Smith, Received 9 April 1798 (B93, HC89) No MS: receipt noted Smith, 436</p>
                <p class="hindent">1798-L-088&nbsp;To Elihu Hubbard Smith, Received 17 April 1798 (B94, HC90) No MS: receipt noted Smith, 438, 442</p>
                <p class="hindent">1798-L-089&nbsp;To Elihu Hubbard Smith, Received 24 April 1798 (B95, HC91) No MS: receipt noted Smith, 439-440</p>
                <p class="hindent">1798-L-090&nbsp;To Susan Potts, Received 24 April 1798 (B96, HC92) No MS: Receipt noted with 090 in Smith, 439-440</p>
                <p class="hindent">1798-L-091&nbsp;To Elihu Hubbard Smith, Received 30 April 1798 (B97, HC93) No MS: Paraphrase Smith, 441</p>
                <p class="hindent">1798-L-092&nbsp;To Elihu Hubbard Smith, Received 7 May 1798 (B98, HC94) No MS: Receipt noted Smith, 444</p>
                <p class="hindent">1798-L-093&nbsp;To Elihu Hubbard Smith, Received 22 May 1798 (B99, HC95) No MS: Receipt noted Smith, 445</p>
                <p class="hindent">1798-L-094&nbsp;To Elihu Hubbard Smith, Received 9 June 1798 (B100, HC96) No MS: Receipt noted Smith, 448</p>
                <p class="hindent">1798-L-095&nbsp;To James Brown, 25 August 1798 (B102, HC98) "heavy rains, uncleansed sinks, and a continuance" No MS: Transcript and paraphrase Dunlap 1815, II.3-4</p>
                <p class="hindent">1798-L-096&nbsp;To [James Brown], [August-September 1798] (B101, HC97) "This romantic turn was not" No MS: Paraphrase Allen, 60-61</p>
                <p class="hindent">1798-L-097&nbsp;To James Brown, 4 September 1798 (B103, HC99) "When did you learn to rely upon rumour and news-paper information" No MS: Transcript and paraphrase Dunlap 1815, II.4-5</p>
                <p class="hindent">1798-L-098&nbsp;To William Dunlap, 4 September 1798 (B104, HC100) "Your letter was very acceptable &amp; seasonable" No MS: Transcript Dunlap 1930, I.335-336</p>
                <p class="hindent">1798-L-099&nbsp;To James Brown, [Between 4 and 12 September 1798] (B105, HC101) "[T]his pestilential air seems to be extending itself" No MS: Transcript Dunlap 1815, II.5</p>
                <p class="hindent">1798-L-100&nbsp;To Maria Nicholson, [Between 7 and 16 September 1798] (B106, HC102) "So! A postscript from whom?" MS Virginia
                </p>
                <p class="hindent">1798-L-101&nbsp;To James Brown, 17 September 1798 (B107, HC103) "When calamity is at a distance" No MS: Transcript Dunlap 1815, II.7-8</p>
                <p class="hindent">1798-L-102&nbsp;To William Dunlap, Received 18 September 1798 (B108, HC104) "10 OClock receive a letter from C B Brown" No MS: Paraphrase Dunlap 1930 I.339; Paraphrase Dunlap 1834, III.5</p>
                <p class="hindent">1798-L-103&nbsp;To [James] Brown, 18 and 20 September 1798 (B109, HC105) "What shall I write" No MS: Transcript Dunlap 1815, II.9-10</p>
                <p class="hindent">1798-L-104&nbsp;To William Dunlap, 21 September 1798 (B110, HC106) "Well my beloved friend!" No MS: Transcript and paraphrase Dunlap 1930, I.341</p>
                <p class="hindent">1798-L-105&nbsp;To [Unknown, possible James Brown], [24 September 1798] (B111, HC107) "the weather has lately changed for the better" No MS: Transcript Dunlap 1815, II.10</p>
                <p class="hindent">1798-L-106&nbsp;To [James] Brown, 25 September 1798 (B112, HC108) "It is with great pleasure, that I now inform you" No MS: Transcript and paraphrase Dunlap 1815, II.10-11</p>
                <p class="hindent">1798-L-107&nbsp;To Armitt Brown, 20 December 1798 (B114, HC110) "What excuse to make for my long silence" No MS: Transcript Dunlap 1815 II.93-94</p>
                <p class="hindent">1798-L-108&nbsp;To Thomas Jefferson, 25 December 1798 (B115, HC109) "After some hesitation a stranger to the person" MS LC
                </p>
                <p class="hindent">1798-L-109&nbsp;To Armitt Brown, Late December 1798 (B113, HC111) "Eight of my friends here" No MS: Transcript and paraphrase Dunlap 1815, II.11</p>
                <p class="cbb_bold">1799</p>
                <p class="hindent">1799-L-110&nbsp;To A[rmitt] Brown, 1 January 1799 (B116, HC112) "I have neither wife nor children who look" No MS: Transcript Dunlap 1815, II.94-95</p>
                <p class="hindent">1799-L-111&nbsp;To James Brown, 15 February 1799 (B117, HC113) "I know not why I suffered your last" No MS: Transcript Dunlap 1815, II.97-99</p>
                <p class="hindent">1799-L-112&nbsp;To James Brown, 26 July 1799 (B118, HC114) "I am not sure that the present disposition" No MS: Transcript Dunlap 1815, II.95-97</p>
                <p class="cbb_bold">1800</p>
                <p class="hindent">1800-L-113&nbsp;To William P. Beers, 12 February 1800 (B119, HC115) "I am sorry that the first time" MS Virginia
                </p>
                <p class="hindent">1800-L-114&nbsp;To James Brown, April 1800 (B120, HC116) "I received your letter and the volumes" No MS: Transcript Dunlap 1815, II.99-100</p>
                <p class="hindent">1800-L-115&nbsp;To R[obert] P[roud], 1 September 1800 (B121, HC117) "I hoped to have met thee in this city" No MS: Transcript Dunlap 1815, II.100-102</p>
                <p class="hindent">1800-L-116&nbsp;To [Unknown], 15 December 1800 (B122, HC118) "Pray tell me what sort of woman is this" MS Texas
                </p>
                <p class="cbb_bold">1801</p>
                <p class="hindent">1801-L-117&nbsp;To Elizabeth Linn, 17 February [1801] (B123, HC119) "When with you, it is your province to talk" MS Texas
                </p>
                <p class="hindent">1801-L-118&nbsp;To Elizabeth Linn, 20 February [1801] (B124, HC120) "What a melancholy, mortified, perplexed hour" MS Texas
                </p>
                <p class="hindent">1801-L-119&nbsp;To Elizabeth Linn, 28 February [1801] (B125, HC121) "So it seems, my note placed things on their right footing" MS Texas
                </p>
                <p class="hindent">1801-L-120&nbsp;To Elizabeth Linn, 2 March [1801] (B126, HC122) "Seated, I suppose, at her needle" MS Texas
                </p>
                <p class="hindent">1801-L-121&nbsp;To Elizabeth Linn, [Likely 24 February or 3 March 1801] (B155, HC148) "I must subdue this disposition to repine" MS Texas
                </p>
                <p class="hindent">1801-L-122&nbsp;To Elizabeth Linn, 6-7 March [1801] (B127, HC123) "Let me overlook&#x2014;let me erase" MS Texas
                </p>
                <p class="hindent">1801-L-123&nbsp;To Elizabeth Linn, 10 March [1801] (B128, HC124) "I hope, my best friend, thou wilt be abroad" MS Texas
                </p>
                <p class="hindent">1801-L-124&nbsp;To Elizabeth Linn, [Before 17 March 1801] (B154, HC147) "How arrogant &amp; ungrateful was I" MS Texas
                </p>
                <p class="hindent">1801-L-125&nbsp;To Elizabeth Linn, 17-18 March [1801] (B129 & B130, HC125) "What would I not give that every evening" MS Texas
                </p>
                <p class="hindent">1801-L-126&nbsp;To Elizabeth Linn, [Likely 19 March 1801] (B150 & B151, HC144) "So, says my domestic physician" MS Texas
                </p>
                <p class="hindent">1801-L-127&nbsp;To Elizabeth Linn, 23 March [1801] (B131, HC126) "So you wish me to be your task setter" MS Texas
                </p>
                <p class="hindent">1801-L-128&nbsp;To Elizabeth Linn, 27 March [1801] (B133, HC127) "What a peevish, discontented wretch was I" MS Texas
                </p>
                <p class="hindent">1801-L-129&nbsp;To Elizabeth Linn, 30 March [1801] (B134, HC128) "I write in odd situations" MS Texas
                </p>
                <p class="hindent">1801-L-130&nbsp;To Elizabeth Linn, 31 March [1801] (B135, HC129) "I parted from you last night with some uneasiness" MS Texas
                </p>
                <p class="hindent">1801-L-131&nbsp;To Elizabeth Linn, 1 April [1801] (B136, HC130) "What impertinents and headaches" MS Texas
                </p>
                <p class="hindent">1801-L-132&nbsp;To Elizabeth Linn, 2 April [1801] (B137, HC131) "Know you I disposed" MS Texas
                </p>
                <p class="hindent">1801-L-133&nbsp;To Elizabeth Linn, 3-4 [April 1801] (B138 & B139, HC132) "Another charming evening with my love!" MS Texas
                </p>
                <p class="hindent">1801-L-134&nbsp;To Elizabeth Linn, 6 [April 1801] (B140, HC133) "Fancy is a kind friend." MS Texas
                </p>
                <p class="hindent">1801-L-135&nbsp;To Elizabeth Linn, 9 April [1801] (B141, HC134) "You did sit down a few minutes in the day, then" MS Texas
                </p>
                <p class="hindent">1801-L-136&nbsp;To Elizabeth Linn, 10-11 April [1801] (B142 & 132, HC135 & HC136) "I believe I am an arrant simpleton" MS Texas
                </p>
                <p class="hindent">1801-L-137&nbsp;To Elizabeth Linn, 13 April [1801] (B143, HC137) "Did you see your friend to day?" MS Texas
                </p>
                <p class="hindent">1801-L-138&nbsp;To Elizabeth Linn, 14 April [1801] (B144, HC138) "How sweetly serene, how joyously bright" MS Texas
                </p>
                <p class="hindent">1801-L-139&nbsp;To Elizabeth Linn, 16 April [1801] (B145, HC139) "How does my friend to day?" MS Texas
                </p>
                <p class="hindent">1801-L-140&nbsp;To Elizabeth Linn, [Likely 16 April 1801] (B152, HC145) "What words can sufficiently convey" MS Texas
                </p>
                <p class="hindent">1801-L-141&nbsp;To Elizabeth Linn, 19 April [1801] (B146, HC140) "I saw my love an age ago" MS Texas
                </p>
                <p class="hindent">1801-L-142&nbsp;To Elizabeth Linn, [Between 19 and 27 April 1801] (B149, HC143) "Am I not to share with my beloved" MS Texas
                </p>
                <p class="hindent">1801-L-143&nbsp;To Elizabeth Linn, 27 April [1801] (B147, HC141) "Did you not request me to be your monitor; your tutor?" MS Texas
                </p>
                <p class="hindent">1801-L-144&nbsp;To Elizabeth Linn, 29 April [1801] (B148, HC142) "How strange, how whimsical" MS Texas
                </p>
                <p class="hindent">1801-L-145&nbsp;To Elizabeth Linn, [Likely week of 27 April to 1 May 1801] (B157, HC150) "It does not much become a wise man" MS Texas
                </p>
                <p class="hindent">1801-L-146&nbsp;To John E[lihu] Hall, 8 May 1801 (B158, HC151) "The printer has made considerable progress" MS Haverford
                </p>
                <p class="hindent">1801-L-147&nbsp;To Anthony Bleeker, 31 October 1801 (B159, HC152) "I need not say with how much pleasure I read your letter" No MS: Transcript Dunlap 1815, II.103-104</p>
                <p class="cbb_bold">1802</p>
                <p class="hindent">1802-L-148&nbsp;To Mary Linn, 9 January 1802 (B160, HC153) "Will my friend do me the favour to accept" MS Virginia
                </p>
                <p class="hindent">1802-L-149&nbsp;To [William Johnson], 4 May 1802 (B161, HC154) "The bearer of this is Mr. Robert Cumming" MS Harvard
                </p>
                <p class="hindent">1802-L-150&nbsp;To [John Blair Linn], 8 July 1802 (B162, HC155) "Every day have I said: 'Well, this morning I will write'" MS NYPL
                </p>
                <p class="hindent">1802-L-151&nbsp;To Thomas Pym Cope, Received 8 July 1802 (Not in B, HC156) No MS: Paraphrase Cope, 129</p>
                <p class="hindent">1802-L-152&nbsp;To R[ebecca Linn], 13 August 1802 (B163, HC157) "Well, I hope your Sunday's journey" No MS: Transcript Dunlap 1815, II.105-106</p>
                <p class="hindent">1802-L-153&nbsp;To R[ebecca Linn], 9 October 1802 (B164, HC158) "So, my good Rebecca, your brother tells me" No MS: Transcript Dunlap 1815, II.106-108</p>
                <p class="hindent">1801-L-154&nbsp;To Elizabeth Linn, [Likely November or December 1802] (B156, HC149) "I wish I could see &amp; talk with my friend" MS Texas
                </p>
                <p class="hindent">1802-L-155&nbsp;To [Elizabeth Linn], 13 November [1802] (B165, HC159) "I hope to see my beloved in a few hours" MS Texas
                </p>
                <p class="hindent">1802-L-156&nbsp;To Elizabeth Linn, 15 November [1802] (B166, HC160) "I hope your jaunt may be a pleasant one" MS Texas
                </p>
                <p class="hindent">1802-L-157&nbsp;To Elizabeth Linn, 7 December 1802 (B167, HC161) "How did your paper delight &amp; pain me!" MS Texas
                </p>
                <p class="hindent">1802-L-158&nbsp;To Elizabeth Linn, 21 December [1802] (B168, HC162) "This is the first day of resuming this desk" MS Texas
                </p>
                <p class="cbb_bold">1803</p>
                <p class="hindent">1803-L-159&nbsp;To [Elizabeth Linn], 15 January [1803] (B169, HC163) "I wished to greet my dearest friend" MS Texas
                </p>
                <p class="hindent">1803-L-160&nbsp;To R[ebecca Linn], 18 January 1803 (B170, HC164) "Little did either of us dream" No MS: Transcript Dunlap 1815, II.108-110</p>
                <p class="hindent">1803-L-161&nbsp;To Samuel Miller, 16 March 1803 (B171, HC165) "I received your letter by M Linn" MS Princeton
                </p>
                <p class="hindent">1803-L-162&nbsp;To [Elizabeth Linn], 18 March 1803 (B172, HC166) "I want to see you this afternoon" MS Texas
                </p>
                <p class="hindent">1803-L-163&nbsp;To Samuel Miller, 20 June 1803 (B173, HC167) "The enclosed has been the result of several attempts" MS Princeton
                </p>
                <p class="cbb_bold">1804</p>
                <p class="hindent">1804-L-164&nbsp;To [Elizabeth Linn], 25 March 1804 (B174, HC168) "I intended this to be a busy day" MS Texas
                </p>
                <p class="hindent">1804-L-165&nbsp;To John Blair Linn, 4 July 1804 (B175, HC169) "Mrs. L. gives me the pleasure of hearing" No MS: Transcript Dunlap 1815, II.110-112</p>
                <p class="hindent">1804-L-166&nbsp;To William Linn, 8 December 1804 (B176, HC170) "I am sensible that many apologies are due" MS HSP
                </p>
                <p class="cbb_bold">1805</p>
                <p class="hindent">1805-L-167&nbsp;To William Dunlap, 25 February 1805 (B177, HC171) "When I recognized your hand in the superscription" MS HSP
                </p>
                <p class="hindent">1805-L-168&nbsp;To William Dunlap, 6 November 1805 (B178, HC173) "I wish, notwithstanding, my neglect of your last" No MS: Transcript Dunlap 1815, II.112-113</p>
                <p class="cbb_bold">1806</p>
                <p class="hindent">1806-L-169&nbsp;To Thomas Pym Cope, Received 20 January 1806 (Not in B, HC174) No MS: Paraphrase Cope, 192</p>
                <p class="hindent">1806-L-170&nbsp;To Elizabeth Linn Brown, 17 June 1806 (B179, HC175) "I am here in Albany at last" MS HSP
                </p>
                <p class="hindent">1806-L-171&nbsp;To John E[lihu] Hall, 26 July 1806 (B180, HC176) "I hope you have never known by experience" MS Haverford
                </p>
                <p class="hindent">1806-L-172&nbsp;To John H[oward] Payne, 25 August 1806 (B181, HC177) "When I parted with you at Albany" No MS: Transcript Dunlap 1815, II.116-118</p>
                <p class="hindent">1806-L-173&nbsp;To Susan [Linn], [After August]1806 (B183, HC179) "Odd enough, my dear S. that M. should refer you to me" No MS: Transcript Dunlap 1815, 115-116</p>
                <p class="hindent">1806-L-174&nbsp;To John E[lihu] Hall, 21 November 1806 (B182, HC178) "I should deserve to be entirely discarded" MS Virginia
                </p>
                <p class="cbb_bold">1807</p>
                <p class="hindent">1807-L-175&nbsp;To W[illiam] Keese, 16 October 1807 (B184, HC180) "Your agreeable letter arrived this moment" No MS: Transcript Dunlap 1815, II.119-120</p>
                <p class="cbb_bold">1808</p>
                <p class="hindent">1808-L-176&nbsp;To J[ohn] B. Romeyn, 18 January 1808 (B185, HC181) "Permit me to thank you for the kind letter" MS Virginia
                </p>
                <p class="cbb_bold">1809</p>
                <p class="hindent">1809-L-177&nbsp;To [Albert Gallatin], 12 January 1809 (Not in B, HC182) "Tho I have not the pleasure &amp; honour of any formal acquaintance" MS NYHS
                </p>
                <p class="hindent">1809-L-178&nbsp;To J[ohn] H[oward] Payne, [March] 1809 (B186, HC183) "I have not forgotten you" No MS: Transcript Dunlap 1815, II.118-119</p>
                <p class="hindent">1809-L-179&nbsp;To Mary [Linn], Summer 1809 (B187, HC184) "My dearest Mary; instead of wandering about" No MS: Transcript and paraphrase Dunlap 1815, II.86-88</p>
                <div class="spacer"></div>

            </div>


            <h4>A.1. Manuscript Collections for
                Letters</h4>
            <p>Total: 122 Letters in MS in 14 collections.</p>
            <AccordionPanels panels={panels} />


            <h4>Earlier Censuses of Brown's Letters</h4>
            <blockquote class="small">
                <p>Bennett, Charles (1976). "The Letters of Charles Brockden Brown: An Annotated Census." <em>Re sources for American Literary Study </em>6, 164-190.</p>
                <p>Homes, John R. and M.M. Cavnar (1998). "A Revised Checklist of the Letters of Charles  Brockden Brown." Typescript. </p>
            </blockquote>
            <h4>Publications with transcriptions or mentions of the Letters</h4>
            <blockquote class="small">
                <p>Allen, Paul (1975). <em>Life of Charles Brockden Brown</em>, ed. Charles E. Bennett. Delmar, NY: Scholars' Facsimiles and Reprints. </p>
                <p>Clark, David Lee (1952). <em>Charles Brockden Brown: Pioneer Voice of America</em>. Durham: Duke University Press.</p>
                <p>__________ (1948). "Unpublished Letters of Charles Brockden Brown and W. W. Wilkins." <em>University of Texas Studies in English</em>, 17 (June 1948), 75-107. </p>
                <p>Cope, Thomas Pym (1978). <em>Philadelphia Merchant: The Diary of Thomas Pym Cope</em>, 1800-1851. Ed. Eliza Cope Harrison. South Bend, IN: Gateway Editions.</p>
                <p>Dunlap, William (1834). "Charles Brockden Brown." <em>National Portrait Gallery of Distinguished Americans</em>, ed. James Herring and James B. Longacre. 3 vols. New York: M. Bancroft.</p>
                <p>__________ (1832). <em>History of the American Theatre</em>. New York: Harper.</p>
                <p>_________ (1815). <em>Life of Charles Brockden Brown</em>. 2 vols. Philadelphia: James P. Parke, 1815. [Dunlap Life]</p>
                <p>Marble, Annie Russell (1907). <em>Heralds of American Literature</em>. Chicago: University of Chicago Press.</p>
                <p>Peden, William (1944). "Thomas Jefferson and Charles Brockden Brown." <em>Maryland Quarterly</em> 1 (Spring 1944), 65-68. </p>
                <p>Smith, Elihu Hubbard (1973). <em>Diary of Elihu Hubbard Smith</em>, ed. James E. Cronin. Philadelphia: American Philosophical Society.</p>
                <p>Warfel, Harry (1949). <em>Charles Brockden Brown: American Gothic Novelist</em>. Gainesville: University of Florida Press.</p>
            </blockquote>
            <h4>B. Poems in Manuscript and Transcribed in various sources (i.e., poems not published separately).</h4>
            <p>Item number, title, date, ms or transcription location </p>
            <TimelinePanels
                panels={timelinePanels2}
                getContent={(panel) => getContent(panel, timelineContentRef2)}
            />
            <div ref={timelineContentRef2} style={{ display: "none" }}>

                <p class="cbb_bold"> 1786 </p>
                <p class="hindent"> 1786-MP001.  "On Some of His School Fellows." MS poem [1786].  Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), ), volume 1, pages 8-11.  A. </p>
                <p class="cbb_bold"> 1787 </p>
                <p class="hindent"> 1787-MP002.  "Aretas." MS poem [1787].  Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), vol. 30, page 30.  A. </p>
                <p class="hindent"> 1787-MP003.  "For the Grocer's Window." MS poem  [1787].  Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), volume 1, page 12.  A. </p>
                <p class="hindent"> 1787-MP004.  "The Rising Glory of America." MS poem [1787]. Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), volume 30, pages 35-37.  A. </p>
                <p class="hindent"> 1787-MP005.  "The Times."  MS poem [1787].  Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), volume 30, pages 38-42.  A. </p>
                <p class="hindent"> 1787-MP006.  "The Grape and the Tobacco Plant." MS poem [1787].  Transcribed E. Brown. HSP; Brown Family Papers (Collection 84), volume 30, pages 9-10.  A. </p>
                <p class="cbb_bold"> 1788 </p>
                <p class="hindent"> 1788-MP007.  "Epistle the First." MS poem , 8 June 1788.  Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), volume 30, pages 33-37 &amp; 29.  See Holmes (1995).  A. </p>
                <p class="hindent"> 1788-MP008.  "In Praise of Schuylkill." MS poem [13 June 1788].   Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), volume 4.  A. </p>
                <p class="cbb_bold"> 1789 </p>
                <p class="hindent"> 1789-MP009.  "To Miss D.P." MS poem  [1789].  Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), volume 1, page 12.  A. </p>
                <p class="hindent"> 1789-MP010.  "To Estrina." MS poem [1789].  Transcribed Elijah Brown. HSP; Brown Family Papers (Collection 84), volume 1, pages 13-16.  A. </p>
                <p class="cbb_bold"> 1792 </p>
                <p class="hindent"> 1792-MP011.  "Crow and Goose Quill." MS poem. 20 March 1792 Letter to Joseph Bringhurst, Jr., Bowdoin College.  A. </p>
                <p class="hindent"> 1792-MP012.  "In Delphy Town." MS poem. 20 March 1792 Letter to Joseph Bringhurst, Jr., Bowdoin College. A. </p>
                <p class="hindent"> 1792-MP013.  "Loo." ["A Peter-Pindarical Performance"].  MS poem. 9 May 1792 Letter to Joseph Bringhurst, Jr., Bowdoin College.  A. </p>
                <p class="hindent"> 1792-MP014.  "Post-Script." MS poem. 15 May 1792 Letter to Joseph Bringhurst, Jr., Bowdoin College [on envelope side of Letter 1792-L-013 to Bringhurst].  A. </p>
                <p class="hindent"> 1792-MP015.  "Sweet Little Thing."  MS poem, December 1792 Letter to Joseph Bringhurst, Jr., Bowdoin College.  A. </p>
                <p class="hindent"> 1792-MP016.  "When Bringhurst and Wilkins are Here." MS poem, undated letter to William W. Wilkins, sold by Rendell's, 1990, whereabouts unknown. [at end of Letter 1792-L 014 to Wilkins].  A. </p>
                <p class="cbb_bold"> 1794 </p>
                <p class="hindent"> 1794-MP018.  "To D.P." poem inscribed in fly-leaf of Samuel Johnson, Rasselas (London, 1790), now at Bowdoin College [1794].  A. </p>
                <p class="hindent"> 1794-MP018b.  "Devotion (To [Debby Ferris])."  Earliest version of poem later published as "Devotion," enclosed with letter to Deborah Ferris of 4 October 1794.
                    <br />[revised as 1808-02567 "Devotion: An Epistle. To Calista"] </p>
                <p class="cbb_bold"> 1798 </p>
                <p class="hindent"> 1798-MP019.  "To Stella" ["Come forth, my soul"].  New York, September 20, 1798.  Transcribed and attributed in Kennedy:  origin unknown.  A. </p>
                <p class="hindent"> 1798-MP020.  "'Tis Poverty that Destroys the State" [<i>Wieland</i> notebook fragment]. HSP; Brown Family Papers (Collection 84), vol. 24.  A. </p>
                <p class="hindent"> 1798-MP021.  "From Virtue's blissful paths away" [Epigraph in 1798-09000 <i>Wieland; or the Transformation</i>].  A. </p>
                <p class="cbb_bold"> 1799 </p>
                <p class="hindent"> 1799-MP022  "Sleep, extend thy downy pinion" [Helena's Song in 1799-01000, <i>Ormond; or The Secret Witness</i>, Ch. 16].  A. </p>
                <p class="hindent"> 1799-MP023  "The breeze awakes" [Constantia's Song, in 1799-01000, <i>Ormond; or The Secret Witness</i>, Ch. 19].  A. </p>
                <p class="hindent"> 1799-MP024  "Ah! far beyond this world" [Sophia's song, in 1799-01000, <i>Ormond; or The Secret Witness</i>, Ch. 22].  A. </p>
                <p class="cbb_bold"> 1800 </p>
                <p class="hindent"> 1800-MP025.  Jessy's Song.  Poem from the Jessica fragment published in Dunlap (1815), I:168 [1800].  A. </p>
                <p class="cbb_bold"> 1801 </p>
                <p class="hindent"> 1801-MP026.  "Pleasures of the Table." MS poem.  Dated "Phila 2 mo. [February] 1801." HSP; <i>Wieland</i> Notebook (Brown Family Papers [Collection 84], notebook 24), page 33.  B. </p>
                <p class="hindent"> 1801-MP027. "Long Strove a Rueful Fate." MS poem in Letter 1801-L-135 to Elizabeth Linn.  A. </p>
                <p class="hindent"> 1801-MP028. "Inchanting Tongue!" MS poem in Letter 1801-L-138 to Eliz. Linn.  A. </p>
                <p class="hindent"> 1801-MP029. "To Clara (On the Death of a Friend)." Poem transcribed in Dunlap (1815) II, 120-122.  A. </p>
                <p class="hindent"> 1801-MP030.  "They Came at Noon" [July 13, 1801].  Poem transcribed in Thomas Pym Cope's Diary (Cope 1978), 72-73.  A. </p>
                <p class="cbb_bold"> 1806 </p>
                <p class="hindent"> 1806-MP031. "Marriage." MS poem, in Letter 1806-L-174 to John Elihu Hall, 21 November 1806.  A. </p>
                <hr />
            </div>
            <h4>C. Miscellaneous Prose writings in Manuscript</h4>

            <TimelinePanels
                panels={timelinePanels3}
                getContent={(panel) => getContent(panel, timelineContentRef3)}
            />
            <div ref={timelineContentRef3} style={{ display: "none" }}>

                <p class="cbb_bold"> 1783 </p>
                <p class="hindent"> 1783-MM001   "Sample of Liberty to Conscience" (aka "Hume Fragment").  1 page of notes on `                   Hume's History.   MS UVA.  A.
                    [added 4/2007, phb] </p>
                <p class="cbb_bold"> 1790 </p>
                <p class="hindent"> 1790-MM002   Henrietta Letters.  MS Texas.  68 pages.  Epistolary fiction in 17 parts. A.
                    [added 4/2007, phb] </p>
                <p class="cbb_bold"> 1793  [Ellendale fragments] </p>
                <p class="hindent"> [The dating of these fictional fragments is provisional, but falls within 1793-96                           limits.  Bennett (1974, 163-174) proposes a timeline for their
                    composition, but more                                   work will be necessary to confirm it.  The "Ellendale" ensemble also includes "Harry                                  Wallace" and
                    "Signior Adini" fragments published in Dunlap (1815)] </p>
                <p class="hindent"> 1793-MM003   Ellendale Letters (c1793-96), MS Texas.  Two fictional letters, dated 29 and 31                                  August, 1793, concerning the Ellen family and their home
                    Ellendale.  Red stains and                            architectural drawings relate these letters to item 1793-4.  A.
                    [added 4/2007, phb] </p>
                <p class="hindent"> 1793-MM004  Medwaye fragment (c1793-96).  MS HSP. Dreer Collection, American Prose                           Writers. Recto and verso of one manuscript page. Reproduced photographically in
                    Allen                       (1811 [1976]), xlviii-xlix. Prose fragment concerning Mr. Ellen and the character Med                       waye. A.
                    [added 4/2007, phb] </p>
                <p class="hindent"> 1793-MM005  Letter to Susan Godolphin (c1793-96).  MS Texas.  Fictional letter, dated 2-3 July                  1793, concerning utopian communities in Australia, the relation of poetry and
                    history, etc.               [added 4/2007 phb] </p>
                <p class="hindent"> 1793-MM006  "Architectural drawings and notes" (c1793-96).  MS Texas.  39 pages of manuscript               architectural drawings (quasi-Palladian elevations, floor plans, and
                    embellishments) with notes and mathematical calculations seemingly related to plans for historical fictions.  Same               red stains as 1793-1 "Ellendale
                    Letters." A.
                    [added 4/2007, phb] </p>
                <p class="cbb_bold"> 1796 </p>
                <p class="hindent"> 1796-MM007   Alloan fragment no. 1 (c1796-97).  MS HSP,  Brown Family Papers (Collection 84),              volume 25.  Two pages of notes for a pseudo-historical fiction concerning the
                    Alloans, a                          Greek people, and their occupation of China, Tartar-Alloan wars, etc.
                    [added 4/2007, phb] </p>
                <p class="hindent"> 1796-MM008   Alloan fragment no. 2 (c1796-97).  MS Texas.  Fictional fragment concerning Al                                 loan occupation of Japan and its effects on Shintoism. With
                    diagrams and mathematical cal                         culations.
                    [added 4/2007, phb] </p>
                <p class="cbb_bold"> 1798 </p>
                <p class="hindent"> 1798-MM009  Notes for <i>Wieland</i> and other fictions. In notebook 24 Brown Family Papers, HSP        .           Photographically reproduced and transcribed in Bicentennial edition of <i>Wieland</i>, 420-441.
                    [added 4/2007, phb] </p>
                <p class="cbb_bold"> 1800 </p>
                <p class="hindent"> 1800-MM010 Jessy Fragment.  In Brown Family Papers, notebook 12, HSP.  2 pages of plot points             and 25 more of calculations for a plot concerning Jessy (Jessika) in Europe with
                    Harriet                        Finch and her father, with mathematical calculations.  Plot points and calculations of Jessy's                       inheritance bring the narrative to 1800.
                    See discussion in Bennett (1980).
                    [added 4/27, phb] </p>
                <p class="cbb_bold"> 1801 </p>
                <p class="hindent"> 1801-MM011"<b />Fragment of a Journal, AMS, dated 1801 March 9-10<b><i>"</i> (</b>6349 #21; Virginia).  1                     page of a journal; with mathematical calculations,
                    remarks on Jefferson's inaugural                                 address (following the header "Mr. Poulson") and six stanzas of a poem.
                </p>
            </div>
        </>
    );
};

export default ManuscriptsData;